import Layout from '../../../../../layout/Layout'
import PatternCreate from 'templates/presentation/components/organisms/PatternCreate/PatternCreate'

export default function CreateTemplatePage() {
    return (
        <Layout>
            <PatternCreate />
        </Layout>
    )
}
